var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popinTabsContainer"},_vm._l((_vm.popinTabs),function(popinTab,popinTabIndex){return _c('div',{key:popinTabIndex,class:{
      popinTabContainer: true,
      isActiveTab: _vm.selectedIndex === popinTabIndex,
    }},[_c('div',{staticClass:"popinTabContent",on:{"click":function($event){return _vm.switchTab(popinTabIndex, popinTab.target)}}},[_vm._v(" "+_vm._s(_vm.$t(`${popinTab.label}`))+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }